<h3 class="text-primary mb-12 text-4xl font-bold">{{ isArabic() ? supplier?.titleAr : supplier?.titleEn }}</h3>

<div class="flex flex-col gap-11 rounded-xl bg-white px-6 py-12 shadow-2xl">
  <div class="flex items-start gap-4">
    <div class="h-[20rem] flex-2/3 rounded-xl p-8 shadow-2xl">
      <h3 class="border-border-card border-b py-3 text-3xl font-bold">
        {{ isArabic() ? supplier?.titleAr : supplier?.titleEn }}
      </h3>
      <div class="flex flex-col gap-4 py-4">
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold" i18n="@@requestDetailsCreatedOn">Created On:</p>
          <p>{{ supplier?.createdOn | dateTime }}</p>
        </div>
        <div class="grid grid-cols-[220px_1fr] items-center">
          <p class="text-primary font-bold" i18n="@@requestDetailsLastModified">Last Updated:</p>
          <p>{{ (supplier?.lastModifiedOn | dateTime) || "no updates" }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
